import { render } from "./ChapterComponents.vue?vue&type=template&id=646bb637"
import script from "./ChapterComponents.vue?vue&type=script&lang=js"
export * from "./ChapterComponents.vue?vue&type=script&lang=js"

import "./ChapterComponents.vue?vue&type=style&index=0&id=646bb637&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__